export default "/assets/images/hhr-access-screenshot.webp?827c0f8ab895625b10e9adba333a783b";